import React from 'react';
import { useNavigate } from 'react-router-dom';
import mic01 from '../../../../assets/img/desktop/licencias.jpg';
import mic02 from '../../../../assets/img/desktop/pc.jpg';
import mic03 from '../../../../assets/img/desktop/banner_licencia.jpg';
import mic04 from '../../../../assets/img/desktop/Windows10_Footer_Icon_MSStore.png';
import mic05 from '../../../../assets/img/desktop/Windows10_Footer_Icon_Skype.png';
import mic06 from '../../../../assets/img/desktop/Logo_Project_108x40.png';
import mic07 from '../../../../assets/img/desktop/iconoSharePoint.png';
import mic08 from '../../../../assets/img/desktop/Logo_Visio_White_90x40.png';
import mic09 from '../../../../assets/img/desktop/Windows10_Footer_Icon_Office.png';
import mic10 from '../../../../assets/img/desktop/cintillonube.jpg';
import mic11 from '../../../../assets/img/desktop/365.png';
import mic12 from '../../../../assets/img/desktop/azure.png';
import mic13 from '../../../../assets/img/desktop/microsoft-sql-server-logo.png';
import mic14 from '../../../../assets/img/desktop/visual-studio-logo.png';
import './CDMicrosoft.css';

function CDMicrosoft() {

    const navigate = useNavigate();

    function navigateView(name:string) {
        navigate("/" + name);
    }

    return (
        <main id="CDMicrosoft">
            <section id="CDM-c1">
                <h2>Licenciamiento Microsoft</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Licenciamiento Microsoft</li>
                </ul>
            </section>
            <section id="CDM-c2">
                <figure id="CDM-c2__image">
                    <img src={mic01} />
                </figure>
                <div id="CDM-c2__text">
                    <h4>Licencias<strong> originales</strong></h4>
                    <p className="text-p1">Adquiere licencias originales de Microsoft y garantiza que tu organización opere de forma segura, productiva y alineada a los estándares actuales.</p>
                    <p className="text-p2">Como Socio de Negocios de Microsoft, en INFRASOL te asesoramos en la selección, implementación y administración de soluciones Microsoft.</p>
                    <p className="text-p3">Aseguramos el cumplimiento legal, la optimización de costos y el máximo aprovechamiento de la tecnología.</p>
                </div>
            </section>
            <section id="CDM-c3">
                <div id="CDM-c3__item1">
                    <div id="CDM-c3__item1--image">
                        <figure>
                            <img src={mic02} />
                        </figure>
                    </div>
                    <div id="CDM-c3__item1--text">
                        <h2>Windows para empresas</h2>
                        <p>Te asesoramos en la elección del sistema operativo más adecuado para tus estaciones de trabajo, dispositivos y servidores, considerando el tamaño, sector y necesidades de tu organización.</p>
                    </div>
                </div>
                <div id="CDM-c3__item2">
                    <div id="CDM-c3__item2--text">
                        <h2>Windows 10 / Windows 11</h2>
                        <div></div>
                        <p >Actualización y migración segura.</p>
                        <p ><strong>Compatibilidad</strong> con hardware y software existente.</p>
                        <p >Configuración recomendada según tu entorno.</p>
                    </div>
                </div>
                <div id="CDM-c3__item3">
                    <div id="CDM-c3__item3--text">
                        <h2>Windows Server</h2>
                        <div></div>
                        <p>Mejora la disponibilidad, seguridad y rendimiento de tus servicios de red y aplicaciones con Windows Server.</p>
                        <p>Virtualización y alta disponibilidad, optimización de almacenamiento y redes, infraestructura de escritorio virtual (VDI) y seguridad avanzada de la información.</p>
                    </div>
                </div>
            </section>
            <section id="CDM-c4">
                <figure id="CDM-c4__image">
                    <img src={mic03} />
                </figure>
                <div id="CDM-c4__text">
                    <h4>Microsoft 365</h4>
                    <p>Impulsa la productividad de tu empresa con herramientas colaborativas modernas, accesibles desde cualquier lugar y dispositivo.</p>
                    <p >Incluye Outlook, Word, Excel, PowerPoint, Exchange Online, Teams, SharePoint Online y OneDrive. Reduce costos de infraestructura y mejora la colaboración entre equipos.</p>
                    <div>
                        <p onClick={() => navigateView("Contacto")}>Solicitar Cotización</p>
                    </div>
                </div>
            </section>
            <section id="CDM-c5">
                <div>
                    <ul className="CDM-c5__lista">
                        <li className="CDM-c5__lista--item">
                            <div className="CDM-c5__lista--item_image">
                                <figure>
                                    <img src={mic04} />
                                </figure>
                                <p>Exchange</p>
                            </div>
                            <div className="CDM-c5__lista--item_text">
                                <p>Correo empresarial seguro y confiable, administrado localmente o desde la nube según tus necesidades (On-Premise y Online).</p>
                            </div>
                        </li>
                        <li className="CDM-c5__lista--item">
                            <div className=" CDM-c5__lista--item_image">
                                <figure>
                                    <img src={mic05} />
                                </figure>
                                <p>Teams</p>
                            </div>
                            <div className="CDM-c5__lista--item_text">
                                <p>Herramienta de colaboración y comunicación empresarial que integra chat, videollamadas, reuniones en línea, compartición de archivos y trabajo colaborativo en tiempo real. Se integra con Microsoft 365 y permite trabajar desde cualquier lugar y dispositivo.
                                </p>
                            </div>
                        </li>
                        <li className="CDM-c5__lista--item">
                            <div className=" CDM-c5__lista--item_image">
                                <figure>
                                    <img src={mic06} />
                                </figure>
                                <p>Project</p>
                            </div>
                            <div className="CDM-c5__lista--item_text">
                                <p>Herramienta de gestión de proyectos que permite planificar, asignar recursos, hacer seguimiento de tareas y generar reportes de estado. Facilita la coordinación de equipos y la entrega de proyectos a tiempo.</p>
                            </div>
                        </li>
                    </ul>
                    <ul className="CDM-c5__lista">
                        <li className="CDM-c5__lista--item">
                            <div className=" CDM-c5__lista--item_image">
                                <figure>
                                    <img src={mic07} />
                                </figure>
                                <p>SharePoint</p>
                            </div>
                            <div className="CDM-c5__lista--item_text">
                                <p>Plataforma de colaboración y gestión de contenido disponible como SharePoint Server (on-premise) o SharePoint Online (parte de Microsoft 365). Facilita el trabajo colaborativo, la gestión documental, la creación de sitios de equipo y portales empresariales, con acceso seguro desde cualquier lugar y dispositivo.</p>
                            </div>
                        </li>
                        <li className="CDM-c5__lista--item">
                            <div className=" CDM-c5__lista--item_image">
                                <figure>
                                    <img src={mic08} />
                                </figure>
                                <p>Visio</p>
                            </div>
                            <div className="CDM-c5__lista--item_text">
                                <p>Herramienta para crear diagramas profesionales, diagramas de flujo, organigramas y diagramas técnicos. Permite simplificar información compleja mediante visualizaciones claras y colaborativas.</p>
                            </div>
                        </li>
                        <li className="CDM-c5__lista--item">
                            <div className=" CDM-c5__lista--item_image">
                                <figure>
                                    <img src={mic09} />
                                </figure>
                                <p>Office</p>
                            </div>
                            <div className="CDM-c5__lista--item_text">
                                <p>Suite de productividad que incluye Word, Excel, PowerPoint, Outlook, OneNote y más, disponible como Microsoft 365 (suscripción en la nube) o como versión de escritorio. Permite trabajar de manera unificada desde Windows, Mac y dispositivos móviles, con sincronización en la nube y colaboración en tiempo real.</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section id="CDM-c6">
                <figure id="CDM-c6__image">
                    <img src={mic10} />
                </figure>
                <div id="CDM-c6__text">
                    <p>Reduce tus costos de infraestructura, personal y equipamiento</p>
                    <p>¡INVIERTE EN LA NUBE!</p>
                </div>
            </section>
            <section id="CDM-c7">
                <div id="CDM-c7__office">
                    <h4>Office 365</h4>
                    <div></div>
                    <figure>
                        <img src={mic11} />
                    </figure>
                    <p>Con office 365 impulsas la productividad en tu empresa, gracias a a que todo lo que se puede hacer en la oficina, ahora también se puede hacer fuera de esta.
                        Herramientas flexibles que se ajustan a las necesidades de los empleadosde hoy en día para que su grado de satisfacción aumente.</p>
                </div>
                <div id="CDM-c7__azure">
                    <h4>Microsoft Azure</h4>
                    <div></div>
                    <figure>
                        <img src={mic12} />
                    </figure>
                    <p><strong>Azure</strong> es la <strong>plataforma de informática en la nube de Microsoft,</strong>una colección cada vez mayor de servicios integrados (análisis, proceso, base de datos, móviles,
                        redes, almacenamiento y web) para moverse con más rapidez, llegar más lejos y ahorrar dinero.</p>
                    <p>Microsoft Azure es una <strong>plataforma abierta y flexible</strong>que le permite construir rápidamente, implementar y administrar aplicaciones a través de una red global
                    de centros de datos gestionados por Microsoft. Integra tus aplicaciones de nube pública con tu entorno de TI actual y genera aplicaciones utilizando cualquier
                        idioma, herramienta o entorno de desarrollo.</p>
                </div>
            </section>
            <section id="CDM-c8">
                <figure id="CDM-c8__image">
                    <img src={mic10} />
                </figure>
                <div id="CDM-c8__text">
                    <p>Para tu equipo de Desarrollo de Software</p>
                    <p>Entornos de desarrollo de aplicaciones e interfaces amigables y fáciles de utilizar</p>
                </div>
            </section>
            <section id="CDM-c9">
                <div id="CDM-c9__sql">
                    <h4>SQL Server</h4>
                    <div></div>
                    <figure>
                        <img src={mic13} />
                    </figure>
                    <p>Plataforma de base de datos empresarial para aplicaciones críticas, análisis de datos y entornos híbridos.</p>
                </div>
                <div id="CDM-c9__visual">
                    <h4>Visual Studio</h4>
                    <div></div>
                    <figure>
                        <img src={mic14} />
                    </figure>
                    <p>Entorno de desarrollo integrado para crear aplicaciones modernas para escritorio, web, móviles y nube.</p>
                </div>
            </section>
        </main>
    );
}

export default CDMicrosoft;